<template>
    <el-dialog ref="changeOrderDialog" :before-close="handleDialogClose"	:modal-append-to-body="false" :close-on-click-modal="false" title="选择订单" :visible.sync="changeOrderDialog" class="custom-form-dialog custom_dialog" width="860px">
        <div class="detail">
            <div class="relate_approval_wrap">
                <div class="relate_approval_search">
                    <el-input size="small" v-model="searchForm.keyword" placeholder="请输入搜索内容"  clearable  @clear="handleClickSearch"  @keyup.enter.native="handleClickSearch">
                        <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                    </el-input>
                    <el-date-picker  v-model="searchForm.created_at" size="small"  format="yyyy-MM-dd" value-format="yyyy-MM-dd"  type="daterange" @change="handleClickSearch" start-placeholder="创建开始日期"
                                     end-placeholder="创建结束日期"> </el-date-picker>
                </div>
                <div class="relate_approval_list">
                    <el-table class="custom_table" :data="tableData" border height="480px" ref="multipleTable" row-key="order_id"  @selection-change="handleSelectionChange">
                        <el-table-column :resizable="false" type="selection"   align="center"  width="45" :reserve-selection="true" :selectable="isSelectable"></el-table-column>
                        <el-table-column label="订单编号" prop="code" show-overflow-tooltip width="155px">
                            <template slot-scope="{row}">
                                <span class="link-label" @click="handleClickOrderDetail(row)" v-text="row.order_num"></span>
                            </template>
                        </el-table-column>

                        <el-table-column label="关联商机" prop="project_name" show-overflow-tooltip min-width="140px">
                            <template slot-scope="{row}">
                                <span class="link-label" @click="handleClickBusinessDetail(row)" v-text="row.project_name"></span>
                            </template>
                        </el-table-column>

                         <el-table-column label="关联客户" prop="customer_name" show-overflow-tooltip min-width="140px">
                             <template slot-scope="{row}">
                                 <span class="link-label" @click="handleClickCompanyDetail(row)" v-text="row.customer_name"></span>
                             </template>
                         </el-table-column>

                         <el-table-column label="客户联系人" prop="contact_name" show-overflow-tooltip width="100px"> </el-table-column>

                         <el-table-column label="销售" prop="salesperson_name" show-overflow-tooltip width="110px">
                              <template #default="{ row }">
                                  <userDetailPopover v-if="row.salesperson" :uid="row.salesperson">
                                      <div slot="container">
                                          <div class="user_head">
                                              <img :src=" row.salesperson_avatar ? row.salesperson_avatar : defaultImg" alt="" />
                                              <span v-text="row.salesperson_name"></span>
                                          </div>
                                      </div>
                                  </userDetailPopover>
                              </template>
                         </el-table-column>

                         <el-table-column label="订单总金额" prop="total_price" show-overflow-tooltip width="110px"></el-table-column>
                    </el-table>
                </div>
                <div class="relate_approval_page">
                    <el-pagination background
                                   size="mini"
                                   @size-change="handleSizeChange"
                                   @current-change="handleCurrentChange"
                                   :current-page="pagination.pageNum"
                                   :page-sizes="pagination.pageSizes"
                                   :page-size="pagination.pageSize"
                                   :layout="pagination.layout"
                                   :pager-count="5"
                                   :total="pagination.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button :disabled="BtnDisabled" type="primary" @click.stop="handleDialogConfirm" >确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {getOrderList } from "@/api/index.js"
import {pagination} from '@/mixins'
import userDetailPopover from "@/components/pComponents/userDetailPopover";
export default {
    name: "change_order",
    components: {
        userDetailPopover
    },
    props: {
        changeOrderDialog: {
            type: Boolean,
            default: false
        },
        order_pk_sort: {
            type: Object,
            default: ()=>{}
        },
        selectOrderData: {
            type: Array,
            default: ()=>[]
        },
        disabledData: {
            type: Array,
            default: ()=>[]
        }, //不可选择的订单
    },
    mixins: [pagination],
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            BtnDisabled:false,
            searchForm:{
                keyword:'',
                created_at:[]
            },
            tableData:[],
            select_order_ids:[],
            multipleSelection:[]
        }
    },
    created() {
        this.$nextTick(()=>{
            this.multipleSelection = JSON.parse(JSON.stringify(this.selectOrderData))
            this.multipleSelection.forEach(row => {
                this.$refs.multipleTable.toggleRowSelection(row);
            });
        })

        this.getOrderList()

    },
    methods: {
        isSelectable(row, index) {
            return this.disabledData.find(find => find.order_id == row.order_id) ?  false  : true
        },
        handleSelectionChange(selection){
            this.multipleSelection = selection;
        },
        handleClickSearch(){
            this.getOrderList()
        },
        // 页码改变
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            this.handleClickSearch();
        },
        // 页数改变
        handleSizeChange(page) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = page.pageSize
            this.handleClickSearch();
        },
        getOrderList() {
            getOrderList({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword:this.searchForm.keyword,
                created_at:this.searchForm.created_at,
                pk_sort:this.order_pk_sort,
                status:0
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.tableData = data
                    this.pagination.total = total

                } else {
                    this.$message.error(res.message)
                }
            })
        },
        handleDialogClose() {
            this.$emit("update:changeOrderDialog", false)
        },
        handleDialogConfirm() {
            this.$emit("update:changeOrderDialog", false)
            this.$emit('success', this.multipleSelection)
        },

        //点击查看商机详情
        handleClickBusinessDetail(row) {
            this.$router.push({
                name: "BusinessDetail",
                params: {
                    isPush: true,
                },
                query: {
                    project_id: row.project_id,
                    name: row.project_name,
                },
            });
        },
        //点击查看关联客户详情
        handleClickCompanyDetail(row) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: row.customer_id,
                    name: row.customer_name,
                },
            });
        },
        // 订单详情
        handleClickOrderDetail(row){
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id:row.order_id,
                    name:row.order_num,
                },
            });
        },

    }
}
</script>
<style lang="scss" scoped>
.custom_dialog{

}
.user_head{
    width: 100%;
    line-height: 24px;
    display: flex;
    align-items: center;
    cursor: pointer;
    img{
        width: 24px;
        height: 24px;
        border-radius: 50%;
        display: inline-block;
        margin-right: 8px;
    }
    span{
        font-size: 14px;
        color: rgb(102, 102, 102);
    }
}
.relate_approval_wrap{
    width: 100%;
    .relate_approval_search{
        display: flex;
        margin-bottom: 16px;
        .el-select{
            width: 272px;

        }
        .el-input{
            width: 272px;
            margin-right: 16px;
        }
        ::v-deep .el-input__suffix {
            line-height: 32px;
        }
    }
    .relate_approval_list{

    }
    .relate_approval_page{
        padding: 16px 0 0;
        box-sizing: border-box;
    }
}

</style>
